import { FC } from 'react';
import * as React from 'react';
import PanelText from './Panels/PanelText';
import PanelVideo from './Panels/PanelVideo';
import PanelImage from './Panels/PanelImage';
import PanelSeparator from './Panels/PanelSeparator';

export type Panels = {
  panels: IDto[];
};

type Props = Panels;

const Panels: FC<Props> = ({ panels }) => {

  return (
    <>
        {
          panels.map((panel, i) => {
            switch (panel.type) {

              case "PanelText":
                const panelText = panel as PanelTextDto;
                return <PanelText {...panelText} key={`panel-text-${i}`} />

              case "PanelImage":
                const panelImages = panel as PanelImageDto;
                return <PanelImage {...panelImages} key={`panel-image-${i}`} />

              case "PanelVideo":
                const panelVideo = panel as PanelVideoDto;
                return <PanelVideo {...panelVideo} key={`panel-video-${i}`} />

                case "PanelSeparator":
                  const panelSeparator = panel as PanelSeparatorDto;
                  return <PanelSeparator {...panelSeparator} key={`panel-separator-${i}`} />
  
              default:
                return null;
            }
          })
        }
    </>
  );
};

export default Panels;


// WEBPACK FOOTER //
// ./src/Components/Panels.tsx